var map = {
	"./alveolar/cover.png": "2511",
	"./american-box/cover.png": "0282",
	"./bottle-box/cover.png": "b878",
	"./coat-hanger-box/cover.png": "68cb",
	"./corner/cover.png": "edb6",
	"./corrugated-paper/cover.png": "cca4",
	"./expositor/cover.png": "aa88",
	"./litographed-box/cover.png": "a0b9",
	"./punched-box/cover.png": "4125"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25aa";